(function () {
  function copyURI(e, copyLink) {
    e.preventDefault();

    const url = copyLink.dataset.copyHref || window.location.href;

    const handleCopy = (btn, success) => {
      if (success) {
        btn.classList.add("copied");
        setTimeout(() => btn.classList.remove("copied"), 1000);
      } else {
        btn.classList.add("notCopied");
        setTimeout(() => btn.classList.remove("notCopied"), 1000);
      }
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => handleCopy(copyLink, true))
        .catch(() => handleCopy(copyLink, false));
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = url;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand("copy");
        handleCopy(copyLink, successful);
      } catch (err) {
        handleCopy(copyLink, false);
      }

      document.body.removeChild(textArea);
    }
  }

  function bindCopyLinks(root = document) {
    const copyLinks = root.querySelectorAll(".copy-btn");

    copyLinks.forEach((copyLink) => {
      if (copyLink.dataset.copyBound === "true") return;

      copyLink.dataset.copyBound = "true";
      copyLink.addEventListener("click", (e) => copyURI(e, copyLink));
    });
  }

  bindCopyLinks();

  document.addEventListener("shopify:section:load", (event) =>
    bindCopyLinks(event.target)
  );
})();
